import { useSyncExternalStore } from 'react';
const subscribe = (): (() => void) => () => {};
const getSnapshot = (): boolean => true;
const getServerSnapshot = (): boolean => false;

/**
 * True once the component has hydrated on the client. Used to defer
 * rendering of chrome that would otherwise mismatch between the server
 * render (no session yet) and the first client render (session may already
 * be populated). Implemented with `useSyncExternalStore` instead of a
 * `useEffect` + `setState` mount flag (react-hooks/set-state-in-effect) --
 * the server/client snapshot mismatch is exactly what the API exists to
 * reconcile after hydration.
 */
export function useHasMounted() {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}